import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { getStationData } from "../util";
import Box from "@mui/material/Box";

// Load weather and lake temperature forecasts
// let [vmax, speed, dir, t2m, precip, dursun, twater] = await loadData("TEL");
// let qff1 = await loadQFF("KLO_LUG");
// let qff2 = await loadQFF("KLO_GVE");


export default function Alpnachersee ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "TEL", "lucernealpnachersee", "QFF_KLO_LUG");

  return (
    <div>
      <title>Alpnachersee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Alpnachersee</h2>
          <h3>Tellikurve</h3>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <PressurePlot qff={qff} label="Zürich − Lugano" label_plus="Nordwind" label_minus="Föhn" />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
          <a href="https://www.limmattalerwetter.ch/forecast/lake_lucerne.webp">
            <img
              className="windplot"
              src="https://www.limmattalerwetter.ch/forecast/lake_lucerne.webp"
              alt="Map of probability of wind exceeding threshold"
            />
          </a>
        </div>
      </div>
    </div>
  );
};
